import ProductIcon from './ProductIcon';

export default ProductIcon;
